import * as Authentication from './lib/proxies/authentication';
import * as Businesses from './lib/proxies/businesses';
import * as BusinessLockers from './lib/proxies/businessLockers';
import * as BusinessSpecific from './lib/proxies/businessSpecific';
import * as Categories from './lib/proxies/categories';
import * as Core from './lib/proxies/core';
import * as CustomDrinks from './lib/proxies/customDrinks';
import * as Customers from './lib/proxies/customers';
import * as Dashboard from './lib/proxies/dashboard';
import * as Images from './lib/proxies/images';
import * as Menu from './lib/proxies/menu';
import * as Orders from './lib/proxies/orders';
import * as Places from './lib/proxies/places';
import * as Products from './lib/proxies/products';
import * as Servings from './lib/proxies/servings';
import * as StandardDrinks from './lib/proxies/standardDrinks';
import * as Stripe from './lib/proxies/stripe';
import * as Users from './lib/proxies/users';

export * from './lib/publicApi';
export * from './lib/api';
export * from './lib/baseUrl';
export * from './lib/utils';

export default {
    Authentication,
    Businesses,
    BusinessLockers,
    Customers,
    Dashboard,
    Images,
    Places,
    Stripe,
    Users,
    BusinessSpecific,
    Categories,
    Core,
    CustomDrinks,
    Menu,
    Orders,
    Products,
    Servings,
    StandardDrinks,
};
